module.exports = __webpack_public_path__ + "assets/icons/ic_arrow_forward_24px.svg";